<template>
  <v-container fluid class="pa-0">
    <div v-if="$store.state.api_token">
      <v-app-bar color="indigo accent-4" dark dense height="33" elevation="4">
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
        <v-app-bar-title>
          <div class="title_tenpo">
            {{ $store.state.tenpoName }}
          </div>
        </v-app-bar-title>
        <v-spacer />
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="white" v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list width="250px" height="180px">
            <v-list-item>
              <v-list-item-content>
                Appバージョン：{{ $store.state.version }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                店舗：{{ $store.state.tenpoName }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                ユーザー：{{ $store.state.shainName }}({{ $store.state.shaincd }})
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" absolute temporary :width="230">
        <v-list nav dense>
          <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">

            <v-list-item @click="Top">
              <v-list-item-icon>
                <v-icon large color="light-blue darken-3">mdi-account-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">Top</v-list-item-title>
            </v-list-item>

            <v-list-item @click="InputInventory">
              <v-list-item-icon>
                <v-icon large color="green darken-1">mdi-clipboard-edit-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">棚卸入力</v-list-item-title>
            </v-list-item>

            <v-list-item @click="ProcessingMaterial" :disabled="$store.state.tenpoCd === null">
              <v-list-item-icon :class="{ 'v-icon--disabled': $store.state.tenpoCd === null }">
                <v-icon large color="green darken-1">mdi-clock-time-five-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">加工登録</v-list-item-title>
            </v-list-item>

            <v-list-item @click="RegistrationProduct" :disabled="$store.state.tenpoCd === null">
              <v-list-item-icon :class="{ 'v-icon--disabled': $store.state.tenpoCd === null }">
                <v-icon large color="green darken-1">mdi-playlist-remove</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">廃棄登録</v-list-item-title>
            </v-list-item>

            <v-list-item @click="ChangeTenpo">
              <v-list-item-icon>
                <v-icon large color="orange darken-4">mdi-home-switch-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">店舗選択</v-list-item-title>
            </v-list-item>

            <v-list-item @click="ComfirmLogout">
              <v-list-item-icon>
                <v-icon large>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="title_sentence body-1">ログアウト</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </div>

    <v-dialog v-model="dialog_confirm" max-width="290">
      <v-card>
        <v-card-title class="headline">確認</v-card-title>
        <v-card-text>
          入力中の棚卸データは削除されます。<br>
          ログアウトしますか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_confirm = false">
            戻る
          </v-btn>
          <v-btn color="red darken-1" text @click="dialog_confirm = false" v-on:click="DoLogout">
            ログアウト
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>

export default {
  name: 'Header',
  data() {
    return {
      noTenpoSelected: true,
      drawer: false,
      group: null,
      dialog_confirm: false,
    }
  },
  methods: {
    InputInventory() {
      this.drawer = false;
      this.$router.push({ name: 'InputInventory' }).catch(() => { });
    },
    ProcessingMaterial() {
      this.drawer = false;
      this.$router.push({ name: 'ProcessingMaterial' }).catch(() => { });
    },
    RegistrationProduct() {
      this.drawer = false;
      this.$router.push({ name: 'RegistrationProduct' }).catch(() => { });
    },
    ChangeTenpo() {
      this.drawer = false;
      this.$router.push({ name: 'TenpoSelect' }).catch(() => { });
    },
    Top() {
      this.drawer = false;
      this.$router.push({ name: 'Top' }).catch(() => { });
    },
    ComfirmLogout() {
      this.drawer = false;
      this.dialog_confirm = true;
    },
    DoLogout() {
      this.drawer = false;
      this.$store.dispatch("auth", {
        kaisyacd: null,
        shaincd: null,
        shainName: null,
        api_token: null,
        version: this.$store.state.version
      });
      this.$store.dispatch("storeData", {
        date: null,
        mode: null,
        inputData: {}
      });
      this.$router.push({ name: 'Top' }).catch(() => { });
      // 画面リロード
      // window.location.reload(true);
    },
  }
}
</script>

<style scoped>
.title_tenpo {
  width: 200px;
  text-align: left;
}

.title_sentence {
  text-align: left;
}

.v-icon--disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>